import { NumberField as BaseNumberField } from '@connected/form-fields/components/number';

import type { FormTableFieldApi } from '../types';

export type NumberFieldProps = {
    /** Field API from FormTable cell renderer */
    field: FormTableFieldApi<number | null | undefined>;
    /** Input placeholder text */
    placeholder?: string;
    /** Whether the field is disabled */
    disabled?: boolean;
    /** Minimum value */
    min?: number;
    /** Maximum value */
    max?: number;
    /** Step value for increment/decrement */
    step?: number;
    /** Maximum decimal precision */
    maxPrecision?: number;
    /** Whether to clamp values to min/max */
    clamp?: boolean;
    /** Additional class name */
    className?: string;
    /** Called when field value changes (for custom side effects like API patching) */
    onValueChange?: (value: number | null) => void;
};

/**
 * NumberField - A number input wrapper for use in FormTable cells.
 *
 * Integrates with FormTable's field API to provide form-connected number input.
 */
export function NumberField({
    field,
    placeholder,
    disabled = false,
    min,
    max,
    step,
    maxPrecision,
    clamp,
    className = 'w-full',
    onValueChange,
}: NumberFieldProps) {
    return (
        <BaseNumberField
            name={field.name}
            value={field.state.value as number | null ?? null}
            onChange={(value) => {
                field.handleChange(value);
            }}
            onBlur={() => {
                field.handleBlur();
                // Trigger side effect (e.g., API patch) on blur
                if (onValueChange) {
                    onValueChange(field.state.value as number | null);
                }
            }}
            placeholder={placeholder}
            disabled={disabled}
            min={min}
            max={max}
            step={step}
            maxPrecision={maxPrecision}
            clamp={clamp}
            className={className}
        />
    );
}
